import React, { useState } from "react";

const DeleteRequestModal = ({ open, onClose, onSubmit, item }) => {
  const [reason, setReason] = useState("");

  if (!open) return null;

  const handleSubmit = () => {
    if (!reason.trim()) return;

    onSubmit(reason, item);
    setReason("");
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white w-[500px] text-start max-w-[90%] rounded-xl shadow-lg">

        {/* Header */}
        <div className="flex justify-between items-center border-b p-4 bg-[#50869A1A]">
          <h2 className="text-lg font-semibold">Request Delete</h2>

          <button
            onClick={onClose}
            className="text-xl font-bold text-gray-600 hover:text-black"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-4">
          <label className="text-sm  font-semibold text-gray-600">
            Enter reason to request deletion
          </label>

          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason..."
            className="w-full mt-2 border rounded-md p-2 min-h-[100px] focus:outline-none resize-none focus:border-[#50869A]"
          />
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 p-4 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-md text-gray-600"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-[#50869A] text-white rounded-md"
          >
            Send Request
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteRequestModal;